import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0d4c5fcd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "formContainer" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Creación de usuarios", -1))
const _hoisted_5 = { class: "formContainer__element" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Nombre *", -1))
const _hoisted_7 = { class: "formContainer__element" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "lastName" }, "Apellido *", -1))
const _hoisted_9 = { class: "formContainer__element" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "imgUrl" }, "Imagen de Perfil", -1))
const _hoisted_11 = { class: "formContainer__element" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "email" }, "Correo / Username *", -1))
const _hoisted_13 = { class: "formContainer__element" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "password" }, "Contraseña *", -1))
const _hoisted_15 = { class: "formContainer__element" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "headline" }, "Cargo *", -1))
const _hoisted_17 = { class: "formContainer__element" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "profile" }, "Perfil * ", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  value: ""
}, "Seleccione un perfil", -1))
const _hoisted_20 = ["value"]
const _hoisted_21 = { class: "formContainer__element" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "enterprise" }, "Empresa * ", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  value: ""
}, "Seleccione una empresa", -1))
const _hoisted_24 = ["value"]
const _hoisted_25 = { class: "formContainer__element" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-symbols-outlined" }, "person_add", -1))
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = {
  key: 1,
  class: "formContainer__element__button--edit"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-symbols-outlined" }, "edit", -1))
const _hoisted_30 = [
  _hoisted_29
]
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-symbols-outlined" }, "cancel", -1))
const _hoisted_32 = [
  _hoisted_31
]
const _hoisted_33 = { key: 1 }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Actualizar datos básicos", -1))
const _hoisted_36 = { class: "formContainer__element" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Nombre *", -1))
const _hoisted_38 = { class: "formContainer__element" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "lastName" }, "Apellido *", -1))
const _hoisted_40 = { class: "formContainer__element" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "headline" }, "Cargo *", -1))
const _hoisted_42 = { class: "formContainer__element" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-symbols-outlined" }, "person_add", -1))
const _hoisted_44 = [
  _hoisted_43
]
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Actualizar tu imagen de perfil", -1))
const _hoisted_47 = { class: "formContainer__element" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "imgUrl" }, "Imagen de Perfil", -1))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Actualizar tu contraseña", -1))
const _hoisted_51 = { class: "formContainer__element" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "email" }, "Correo / Username *", -1))
const _hoisted_53 = { class: "formContainer__element" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "password" }, "Contraseña anterior *", -1))
const _hoisted_55 = { class: "formContainer__element" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "password" }, "Nueva Contraseña *", -1))
const _hoisted_57 = { class: "formContainer__element" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "password" }, "Confirmar Nueva Contraseña *", -1))
const _hoisted_59 = { class: "formContainer__element" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-symbols-outlined" }, "person_add", -1))
const _hoisted_61 = [
  _hoisted_60
]
const _hoisted_62 = { key: 2 }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Gestión de Usuarios", -1))
const _hoisted_65 = { class: "formContainer__element" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "profile" }, "Perfil * ", -1))
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  value: ""
}, "Seleccione un perfil", -1))
const _hoisted_68 = ["value"]
const _hoisted_69 = { class: "formContainer__element" }
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "enterprise" }, "Empresa * ", -1))
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  value: ""
}, "Seleccione una empresa", -1))
const _hoisted_72 = ["value"]
const _hoisted_73 = { class: "formContainer__element" }
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-symbols-outlined" }, "person_add", -1))
const _hoisted_75 = [
  _hoisted_74
]
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-symbols-outlined" }, "cancel", -1))
const _hoisted_77 = [
  _hoisted_76
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalCharging = _resolveComponent("ModalCharging")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ModalCharging, { open: _ctx.isLoading }, null, 8, ["open"]),
    (_ctx.usedFor === 'creation')
      ? (_openBlock(), _createElementBlock("form", _hoisted_2, [
          _hoisted_3,
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              id: "name",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.firstName) = $event))
            }, null, 512), [
              [_vModelText, _ctx.firstName]
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              id: "lastName",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.lastName) = $event))
            }, null, 512), [
              [_vModelText, _ctx.lastName]
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("input", {
              type: "file",
              onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.prepareFile && _ctx.prepareFile(...args))),
              multiple: ""
            }, null, 32)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _withDirectives(_createElementVNode("input", {
              type: "email",
              id: "email",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.email) = $event))
            }, null, 512), [
              [_vModelText, _ctx.email]
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _withDirectives(_createElementVNode("input", {
              type: "password",
              id: "password",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.password) = $event))
            }, null, 512), [
              [_vModelText, _ctx.password]
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              id: "headline",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.headline) = $event))
            }, null, 512), [
              [_vModelText, _ctx.headline]
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _withDirectives(_createElementVNode("select", {
              name: "profile",
              id: "profile",
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.profile) = $event))
            }, [
              _hoisted_19,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activeProfiles, (profile) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: profile.profile_id,
                  key: profile.profile_id
                }, _toDisplayString(profile.type), 9, _hoisted_20))
              }), 128))
            ], 512), [
              [_vModelSelect, _ctx.profile]
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _hoisted_22,
            _withDirectives(_createElementVNode("select", {
              name: "enterprise",
              id: "enterprise",
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.enterpriseUser) = $event))
            }, [
              _hoisted_23,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.enterprises, (enterprise) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: enterprise.enterprise_id,
                  key: enterprise.enterprise_id
                }, _toDisplayString(enterprise.name), 9, _hoisted_24))
              }), 128))
            ], 512), [
              [_vModelSelect, _ctx.enterpriseUser]
            ])
          ]),
          _createElementVNode("div", _hoisted_25, [
            (_ctx.usedFor === 'creation')
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "formContainer__element__button--create",
                  onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.createUser && _ctx.createUser(...args)))
                }, _hoisted_27))
              : _createCommentVNode("", true),
            (_ctx.usedFor === 'edit')
              ? (_openBlock(), _createElementBlock("button", _hoisted_28, _hoisted_30))
              : _createCommentVNode("", true),
            (_ctx.usedFor === 'edit')
              ? (_openBlock(), _createElementBlock("button", {
                  key: 2,
                  onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.cancelAdd && _ctx.cancelAdd(...args))),
                  class: "formContainer__element__button--cancel"
                }, _hoisted_32))
              : _createCommentVNode("", true)
          ])
        ]))
      : (_ctx.usedFor === 'updateProfile')
        ? (_openBlock(), _createElementBlock("form", _hoisted_33, [
            _hoisted_34,
            _hoisted_35,
            _createElementVNode("div", _hoisted_36, [
              _hoisted_37,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                id: "name",
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.updateUser.firstName) = $event))
              }, null, 512), [
                [_vModelText, _ctx.updateUser.firstName]
              ])
            ]),
            _createElementVNode("div", _hoisted_38, [
              _hoisted_39,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                id: "lastName",
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.updateUser.lastName) = $event))
              }, null, 512), [
                [_vModelText, _ctx.updateUser.lastName]
              ])
            ]),
            _createElementVNode("div", _hoisted_40, [
              _hoisted_41,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                id: "headline",
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.updateUser.headline) = $event))
              }, null, 512), [
                [_vModelText, _ctx.updateUser.headline]
              ])
            ]),
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("button", {
                type: "button",
                class: "formContainer__element__button--create",
                onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.updateUserData && _ctx.updateUserData(...args)))
              }, _hoisted_44)
            ]),
            _hoisted_45,
            _hoisted_46,
            _createElementVNode("div", _hoisted_47, [
              _hoisted_48,
              _createElementVNode("input", {
                type: "file",
                onChange: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.prepareFileUpdate && _ctx.prepareFileUpdate(...args))),
                multiple: ""
              }, null, 32)
            ]),
            _hoisted_49,
            _hoisted_50,
            _createElementVNode("div", _hoisted_51, [
              _hoisted_52,
              _withDirectives(_createElementVNode("input", {
                type: "email",
                id: "email",
                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.updateUser.username) = $event))
              }, null, 512), [
                [_vModelText, _ctx.updateUser.username]
              ])
            ]),
            _createElementVNode("div", _hoisted_53, [
              _hoisted_54,
              _withDirectives(_createElementVNode("input", {
                type: "password",
                id: "password",
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.updateUser.password) = $event))
              }, null, 512), [
                [_vModelText, _ctx.updateUser.password]
              ])
            ]),
            _createElementVNode("div", _hoisted_55, [
              _hoisted_56,
              _withDirectives(_createElementVNode("input", {
                type: "password",
                id: "newPassword",
                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.updateUser.newPassword) = $event))
              }, null, 512), [
                [_vModelText, _ctx.updateUser.newPassword]
              ])
            ]),
            _createElementVNode("div", _hoisted_57, [
              _hoisted_58,
              _withDirectives(_createElementVNode("input", {
                type: "password",
                id: "confirmPassword",
                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.updateUser.confirmPassword) = $event))
              }, null, 512), [
                [_vModelText, _ctx.updateUser.confirmPassword]
              ])
            ]),
            _createElementVNode("div", _hoisted_59, [
              _createElementVNode("button", {
                type: "button",
                class: "formContainer__element__button--create",
                onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.updatePassword && _ctx.updatePassword(...args)))
              }, _hoisted_61)
            ])
          ]))
        : _createCommentVNode("", true),
    (_ctx.usedFor === 'management' && _ctx.userToManage)
      ? (_openBlock(), _createElementBlock("form", _hoisted_62, [
          _hoisted_63,
          _hoisted_64,
          _createElementVNode("h5", null, _toDisplayString(_ctx.userToManage.first_name + ' ' + _ctx.userToManage.last_name), 1),
          _createElementVNode("div", _hoisted_65, [
            _hoisted_66,
            _withDirectives(_createElementVNode("select", {
              name: "profile",
              id: "profile",
              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.userManaged.profile) = $event))
            }, [
              _hoisted_67,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activeProfiles, (profile) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: profile.profile_id,
                  key: profile.profile_id
                }, _toDisplayString(profile.type), 9, _hoisted_68))
              }), 128))
            ], 512), [
              [_vModelSelect, _ctx.userManaged.profile]
            ])
          ]),
          _createElementVNode("div", _hoisted_69, [
            _hoisted_70,
            _withDirectives(_createElementVNode("select", {
              name: "enterprise",
              id: "enterprise",
              "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.userManaged.enterpriseUser) = $event))
            }, [
              _hoisted_71,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.enterprises, (enterprise) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: enterprise.enterprise_id,
                  key: enterprise.enterprise_id
                }, _toDisplayString(enterprise.name), 9, _hoisted_72))
              }), 128))
            ], 512), [
              [_vModelSelect, _ctx.userManaged.enterpriseUser]
            ])
          ]),
          _createElementVNode("div", _hoisted_73, [
            _createElementVNode("button", {
              type: "button",
              class: "formContainer__element__button--create",
              onClick: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.updateUserManagement && _ctx.updateUserManagement(...args)))
            }, _hoisted_75),
            _createElementVNode("button", {
              onClick: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.cancelUserManagement && _ctx.cancelUserManagement(...args))),
              class: "formContainer__element__button--cancel"
            }, _hoisted_77)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}